import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CaretDown = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CaretDown' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='22 8 12 20 2 8' />
  </StyledIcon>
);
